<div class="form-group">
  <div class="relative flex-1">
    <input
      type="text"
      [id]="id()"
      class="outline-none input"
      [formControl]="control"
      [class.filled]="!!control.value"
      [class.has-label]="!!label()"
      (blur)="validateValue()"
    />
    <label class="label" [for]="id()">{{ label() }}</label>
  </div>
  <input type="color" class="color-picker outline-none" [(ngModel)]="colorValue" (ngModelChange)="onInput()" />
</div>
